export const documentStepNameByValue = {
    0: 'Hochgeladen',
    25: 'Bereit',
    50: 'Todo',
    75: 'In Arbeit',
    100: 'Erledigt',
};
